import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { formatCurrency } from '../../services/adminAnalyticsApi';

const COLORS = ['#1a2f5c', '#f5c518', '#10b981', '#8b5cf6', '#f97316', '#0ea5e9', '#ec4899', '#84cc16'];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="ab-card" style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem' }}>
      <p style={{ fontWeight: 600, textTransform: 'capitalize', margin: '0 0 0.25rem' }}>{d.name}</p>
      <p style={{ color: 'var(--ab-muted-fg)', margin: '0.125rem 0' }}>{d.count} policies</p>
      <p style={{ color: 'var(--ab-muted-fg)', margin: '0.125rem 0' }}>{formatCurrency(d.premium)}</p>
    </div>
  );
};

const CoverDistributionChart = ({ distribution = [] }) => {
  const data = distribution
    .map((d) => ({
      name: d.name || 'Unknown',
      count: Number(d.count) || 0,
      value: Number(d.count) || 0,
      premium: Number(d.premium) || 0,
    }))
    .sort((a, b) => b.count - a.count);
  const total = data.reduce((s, i) => s + i.count, 0);

  return (
    <div className="ab-card">
      <div className="ab-card-header">
        <div>
          <h3 className="ab-card-title">Cover Type Distribution</h3>
          <p className="ab-page-subtitle">{total.toLocaleString()} policies by cover type</p>
        </div>
      </div>
      <div className="ab-card-body">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.25rem' }}>
          <div style={{ width: 220, height: 220 }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={58}
                  outerRadius={100}
                  paddingAngle={3}
                  dataKey="value"
                  stroke="none"
                >
                  {data.map((_, i) => (
                    <Cell key={i} fill={COLORS[i % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div style={{ width: '100%', maxWidth: 320 }}>
            {data.map((item, i) => (
              <div key={item.name} style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '0.75rem', alignItems: 'center', marginBottom: '0.5rem', fontSize: '0.8125rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', minWidth: 0 }}>
                  <span style={{ width: 10, height: 10, borderRadius: '50%', background: COLORS[i % COLORS.length], flexShrink: 0 }} />
                  <span style={{ textTransform: 'capitalize', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.name.toLowerCase()}</span>
                </div>
                <span style={{ color: 'var(--ab-muted-fg)', textAlign: 'right' }}>
                  {item.count.toLocaleString()} ({total ? Math.round((item.count / total) * 100) : 0}%)
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverDistributionChart;
